// @flow
import React from 'react';

import { RESORT_BARS } from 'Client/cms/toolkit/constants';

import { LineTitle } from 'Components/widgets/line-title/LineTitle';
import { ProductCatering } from 'Components/widgets/product-catering/ProductCatering';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';

import { productBarsResolver } from './productBars.resolver';

type CMSProps = {
  priceInclude: string,
  resortId: string,
  title: string,
  withSupplement: string,
};

type GQLProps = {
  bars: {
    introduction: {
      included: string,
      withSupplement: string,
    },
    barsList: Array<{
      name: string,
      description: string,
      images: Array<string>,
    }>,
  },
  config: CMSContent,
  resort: Resort,
};

type LineProps = CMSProps & GQLProps;

const ProductBarsLine = ({ bars, config = {}, priceInclude, title, withSupplement }: LineProps) => {
  const intros = bars.introduction
    ? [
        {
          title: priceInclude,
          description: bars.introduction.included,
        },
        {
          title: withSupplement,
          description: bars.introduction.withSupplement,
        },
      ]
    : [];

  const list = bars.barsList.map(bar => {
    const [image] = bar.images;
    return { ...bar, image };
  });

  return (
    <SiteContainer className="Line">
      <LineTitle>{title}</LineTitle>
      <ProductCatering
        intros={intros}
        list={list}
        seeLessLabel={config.common.loadLess}
        seeMoreLabel={config.common.viewMore}
      />
    </SiteContainer>
  );
};

export const productBarsDescriptor = {
  name: RESORT_BARS,
  component: ProductBarsLine,
  resolve: productBarsResolver.resolve,
};
